var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5298 3.80617L10.7237 0L0.533325 10.1938V14H4.3395L14.5298 3.80617ZM10.7254 1.98925L12.5423 3.80617L11.7795 4.56986L9.96259 2.75294L10.7254 1.98925ZM8.96797 3.74669L10.7849 5.56361L4.7489 11.5996L2.93285 9.78093L8.96797 3.74669ZM1.93822 12.5907V10.7764L3.75602 12.5907H1.93822Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/Icon-edit.adf14102.svg";
export { ForwardRef as ReactComponent };